import React, { useState } from "react";
import { Modal, Input, Button, notification } from "antd";
import { WarningOutlined, CheckCircleOutlined } from "@ant-design/icons";
import emailjs from "@emailjs/browser";
import { db } from "../../services/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "./styles.css";

const { TextArea } = Input;

export default function NaoConformidadeModal({ visible, onClose, certificado }) {
  const [descricao, setDescricao] = useState("");
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const usuario = JSON.parse(sessionStorage.getItem("seepilUsuario") || "{}");

  async function handleEnviar() {
    if (!descricao.trim()) {
      notification.warning({ message: "Descreva a não conformidade antes de enviar.", placement: "topRight" });
      return;
    }

    setLoading(true);
    try {
      // Salva no Firestore
      await addDoc(collection(db, "naoConformidades"), {
        certificado_id: certificado?.id || "",
        certificado_tag: certificado?.tag || "",
        certificado_numero: certificado?.numeroCertificado || "",
        certificado_spl: certificado?.spl || "",
        descricao: descricao.trim(),
        usuario_nome: usuario?.nome || usuario?.email || "Cliente",
        cliente_id: usuario?.cliente_id || "",
        status: "aberto",
        criadoEm: serverTimestamp(),
      });

      // Envia e-mail via EmailJS
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: usuario?.nome || usuario?.email || "Cliente",
          certificado_tag: certificado?.tag || "—",
          certificado_numero: certificado?.numeroCertificado || "—",
          certificado_spl: certificado?.spl || "—",
          descricao: descricao.trim(),
          data: new Date().toLocaleString("pt-BR"),
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      setEnviado(true);
    } catch (err) {
      console.error(err);
      notification.error({ message: "Erro ao enviar. Tente novamente.", placement: "topRight" });
    } finally {
      setLoading(false);
    }
  }

  function handleFechar() {
    setDescricao("");
    setEnviado(false);
    onClose();
  }

  return (
    <Modal
      open={visible}
      onCancel={handleFechar}
      footer={null}
      width={500}
      className="nc-modal"
      centered
    >
      {enviado ? (
        <div className="nc-sucesso">
          <CheckCircleOutlined className="nc-sucesso-icon" />
          <h3>Chamado enviado!</h3>
          <p>Nossa equipe analisará a não conformidade e entrará em contato.</p>
          <Button className="nc-btn-fechar" onClick={handleFechar}>Fechar</Button>
        </div>
      ) : (
        <>
          <div className="nc-header">
            <div className="nc-icon"><WarningOutlined /></div>
            <div>
              <h3 className="nc-title">Reportar Não Conformidade</h3>
              <p className="nc-subtitle">Certificado: {certificado?.tag || "—"} {certificado?.numeroCertificado ? `· Nº ${certificado.numeroCertificado}` : ""}</p>
            </div>
          </div>

          <div className="nc-body">
            <label className="nc-label">Descreva a inconsistência ou correção necessária:</label>
            <TextArea
              rows={5}
              placeholder="Ex: A data de calibração está incorreta, deveria ser..."
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              className="nc-textarea"
              maxLength={1000}
              showCount
            />
          </div>

          <div className="nc-footer">
            <Button onClick={handleFechar} className="nc-btn-cancelar">Cancelar</Button>
            <Button
              onClick={handleEnviar}
              loading={loading}
              className="nc-btn-enviar"
            >
              Enviar Chamado
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
}
